/**
 * An email body's inline images, as the server points them at a received
 * message's stored files (`api/src/context/communicationFiles.ts`): an
 * origin-relative `/api/a/files/communication/…` path in a double-quoted `src`.
 *
 * Only that prefix is resolved. Any other relative `src` is the sender's own,
 * and is left as written rather than sent to the API with the user's session.
 */
const COMMUNICATION_FILE_SRC = /(\bsrc\s*=\s*")(\/api\/a\/files\/communication\/[^"]*)"/g;

/**
 * Resolve each inline image path in an HTML body against the API origin. A body
 * rendered off that origin (a native renderer, an iframe on the web app's own
 * origin) would otherwise request it from the wrong host.
 */
export const resolveCommunicationFileSources = (
  html: string,
  resolveApiPath: (path: string) => string,
): string =>
  html.replace(
    COMMUNICATION_FILE_SRC,
    (_match, prefix: string, path: string) => `${prefix}${resolveApiPath(path)}"`,
  );
